export default __webpack_public_path__ + "static/media/usdt.f6ccbac7.svg";